@if (cloneFinalised$ | async) {
  <eco-job-status-placeholder
    title="Clone Successfully Imported!"
    subtitle="Configuration & Data for Tenant were successfully imported."
    >
    <div class="button-container">
      <button mat-raised-button color="accent" (click)="cloneAnotherTenant()">Clone another tenant</button>
    </div>
  </eco-job-status-placeholder>
} @else {
  <form #cloneForm="ngForm">
    <div class="row">
      <div class="control-label">Import Id:</div>
      <mat-form-field class="import-id-container">
        <mat-label>Import Id</mat-label>
        <input matInput name="importId" type="text" [formControl]="importId">
      </mat-form-field>
      @if (importId.touched && isImportIdValid()) {
        <mat-icon class="valid">done</mat-icon>
      }
      @if (importId.touched && !isImportIdValid()) {
        <mat-icon class="invalid">error_outline</mat-icon>
      }
    </div>
    <div class="row">
      <h3>New Tenant</h3>
      <app-new-tenant-form (formSubmitted)="openCloneConfirmationPopup($event)"
        [hasEnvironmentField]="true"
        [isExternalConditionValid]="isImportIdValid()"
      [actionName]="'Clone Import Only'"></app-new-tenant-form>
    </div>
  </form>
}



